import {
  blackColor,
  whiteColor,
  hexToRgb
} from "assets/jss/material-dashboard-react.js";

const cardStyle = {
  card: {
    border: "0",
    marginBottom: "30px",
    marginTop: "30px",
    borderRadius: "6px",
    color: "rgba(" + hexToRgb(blackColor) + ", 0.87)",
    background: whiteColor,
    width: "100%",
    boxShadow: "0 1px 4px 0 rgba(" + hexToRgb(blackColor) + ", 0.14)",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    minWidth: "0",
    wordWrap: "break-word",
    fontSize: ".875rem"
  },
  cardPlain: {
    background: "transparent",
    boxShadow: "none"
  },
  cardProfile: {
    marginTop: "30px",
    textAlign: "center"
  },
  cardChart: {
    "& p": {
      marginTop: "0px",
      paddingTop: "0px"
    }
  },
  cardDashboard: {
    minHeight: 130,
    border: '0 solid rgba(0, 0, 0, 0.125)',
    borderRadius: '0.75rem',
    boxShadow: '0rem 0.25rem 0.375rem -0.0625rem rgb(0 0 0 / 10%), 0rem 0.125rem 0.25rem -0.0625rem rgb(0 0 0 / 6%)',
    overflow: 'visible'
  },
  cardMdBox: {
    height : 65
  },
  cardTypo : {
    color: "#344767", 
    fontFamily:"HelveticaNeueMedium",
    fontWeight: 300,
    textTransform: 'none'
  },
  cardMdInnerBox : {
    paddingBottom : 16,
    paddingLeft : 16,
    paddingRight: 16
  },
  cardParagraph : {
    textTransform :'none',
    fontWeight: 700
  },
  cardLink : {
    color: "#4CAF50",
    "&:hover" :{
      color: "#4CAF50",
    }
  }
};

export default cardStyle;
